import React from "react";
import {
    Collapse, DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    Navbar,
    NavbarToggler,
    NavItem,
    UncontrolledDropdown
} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {Link, NavLink, withRouter} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {bindActionCreators} from "redux";
import {signOut} from "../../../../common/js/auth/auth-actions";
import connect from "react-redux/es/connect/connect";
import common_images from "../../../../common/js/common-images";
import gasnet_logo from "../../../../common/images/GasNet_logo_zelena.png";
import {setLang} from "../../actions/actions";

class NavComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    toggle = () => { this.setState({ isOpen: !this.state.isOpen }); };
    hide = () => { this.setState({ isOpen: false }); };

    signOut = () => {
        if (this.props.auth.user.provider === 'email') {
            this.props.signOut();
        } else {
            window.location = '/auth/saml/logout';
        }
    };

    setLang(lang) {
        this.props.setLang(lang);
    }

    render() {
        const locale = this.props.lang.locale;

        return (
            <Navbar color="white-2" light expand="md" fixed={'top'}>
               
                    <div className='container'>
                        <Link to="/" className='navbar-brand' onClick={this.hide}><img alt="innogy" src={gasnet_logo}/></Link>
                    </div> 

                <div className='container pb-2'>
                    
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="nav-left" navbar>
                            <NavItem onClick={this.hide}>
                                <NavLink className='nav-link' to='/dashboard' exact={true}><FormattedMessage id='app.nav.home'/></NavLink>
                            </NavItem>
                            <NavItem onClick={this.hide}>
                                <NavLink className='nav-link' to='/important-documents'><FormattedMessage id='app.nav.documents'/></NavLink>
                            </NavItem>
                            <NavItem onClick={this.hide}>
                                <NavLink className='nav-link' to='/life-at-innogy'><FormattedMessage id='app.nav.innogy_journey'/></NavLink>
                            </NavItem>
                        </Nav>
                        {/* <Nav className="m-auto d-none d-md-inline-block" navbar>
                            <Link to="/" className='navbar-brand' onClick={this.hide}><img alt="innogy" src={common_images.gasnet_white}/></Link>
                        </Nav> */}
                        <Nav className="nav-right" navbar>
                            {/*<NavItem>*/}
                            {/*    { locale !== 'en' && <span className='nav-item'><span className='nav-link' onClick={() => { this.setLang('en'); }}>en</span></span> }*/}
                            {/*    { locale !== 'cs' && <span className='nav-item'><span className='nav-link' onClick={() => { this.setLang('cs'); }}>cs</span></span> }*/}
                            {/*</NavItem>*/}
                            {!this.props.auth.isAuthenticated &&
                            <NavItem>
                                <NavLink className='nav-link' to='/sign-in'><FormattedMessage id='app.auth.sign_in.title'/></NavLink>
                            </NavItem>
                            }
                            {this.props.auth.isAuthenticated &&
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    <span className='mr-2'>{ this.props.auth.user.employee.name } { this.props.auth.user.employee.surname }</span>
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={this.signOut}>
                                        <FontAwesomeIcon icon={['far', 'sign-out']} className='mr-2'/> <FormattedMessage id='app.nav.sign_out'/>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            }
                        </Nav>
                    </Collapse>
                </div>
            </Navbar>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        lang: state.lang
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        signOut: signOut,
        setLang: setLang
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(NavComponent));
